/* eslint-disable @typescript-eslint/no-explicit-any */
import { useUsersHoursCalendar } from 'packages/blu-booking/src/data_fetching/UserHours/UsersHoursCalendar';
import { useUsersHoursShift } from 'packages/blu-booking/src/data_fetching/UserHours/UsersHoursShift';
import { RootState } from 'packages/blu-booking/src/store';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

interface UseSchedulerDataParams {
  selectedDate: Date;
  selectedPointOfSale: any;
}

/**
 * Gestisce il data fetching del calendario User:
 * - Orari lavorativi per utenti del punto vendita (calendar)
 * - Turni per utenti del punto vendita (shift)
 * - Stato di loading aggregato
 */
export function useSchedulerData({
  selectedDate,
  selectedPointOfSale,
}: UseSchedulerDataParams) {
  const { loadingAppointments } = useSelector(
    (state: RootState) => state.bluBookingaAppointments
  );

  const { filtersLoad } = useSelector(
    (state: RootState) => state.bluBookingCalendarFilters
  );

  const {
    data: calendarPointOfSale,
    isLoading: isLoadingCalendarPointOfSale,
    isSuccess: isSuccessCalendarPointOfSale,
  } = useUsersHoursCalendar({
    pointOfSaleId: selectedPointOfSale?.id,
    selectedDate,
    options: {
      enabled: filtersLoad ?? false,
      refetchInterval: 300000,
    },
  });

  const { data: shiftPointOfSale, isLoading: isLoadingShiftPointOfSale } =
    useUsersHoursShift({
      pointOfSaleId: selectedPointOfSale?.id,
      selectedDate,
      options: {
        enabled: filtersLoad ?? false,
        refetchInterval: 300000,
      },
    });

  const isLoadingWorkHours = useMemo(
    () => isLoadingCalendarPointOfSale || isLoadingShiftPointOfSale,
    [isLoadingCalendarPointOfSale, isLoadingShiftPointOfSale]
  );

  const isLoading = useMemo(
    () => loadingAppointments || isLoadingWorkHours,
    [loadingAppointments, isLoadingWorkHours]
  );

  return {
    calendarPointOfSale,
    shiftPointOfSale,
    isLoading,
    isLoadingWorkHours,
    isLoadingCalendarPointOfSale,
    isLoadingShiftPointOfSale,
    // Orari del giorno e del punto vendita correnti arrivati: senza valore
    // differito, sono gli stessi che riceve lo Scheduler
    isSuccessCalendarPointOfSale,
  };
}
